import { ref } from 'vue'

const notifications = ref([])
let notificationIdCounter = 0

export function useNotifications() {
  function addNotification(type, message, title = null, options = {}) {
    const id = ++notificationIdCounter
    const notification = {
      id,
      type,
      message,
      title,
      autoDismiss: options.autoDismiss !== false,
      duration: options.duration || 3000,
      ...options
    }
    
    notifications.value.push(notification)
    
    // Auto-dismiss logic is now handled in the NotificationSystem component
    return id
  }

  function dismissNotification(id) {
    const index = notifications.value.findIndex(n => n.id === id)
    if (index > -1) {
      notifications.value.splice(index, 1)
    }
  }

  function clearAllNotifications() {
    notifications.value = []
  }

  // Convenience methods for different notification types
  function success(message, title = 'Success!', options = {}) {
    return addNotification('success', message, title, options)
  }

  function error(message, title = 'Error!', options = {}) {
    return addNotification('error', message, title, { ...options, autoDismiss: false })
  }

  function warning(message, title = 'Warning!', options = {}) {
    return addNotification('warning', message, title, options)
  }

  function info(message, title = 'Info!', options = {}) {
    return addNotification('info', message, title, options)
  }

  return {
    notifications,
    addNotification,
    dismissNotification,
    clearAllNotifications,
    success,
    error,
    warning,
    info
  }
} 